/** A quiet perspective checkerboard, used only by Night Game's Services band. */
export function ServiceFieldPattern() {
  const rows = [0, 40, 80, 132, 200, 288, 404, 556, 756, 1016, 1352]
  const columns = Array.from({ length: 40 }, (_, index) => index - 20)
  const project = (column: number, y: number) => 720 + column * 240 * (y + 260) / 1300

  return <svg className="service-field-pattern" aria-hidden="true" focusable="false" width="100%" height="100%" viewBox="0 0 1440 1200" preserveAspectRatio="xMidYMid slice">
    {rows.slice(0, -1).flatMap((top, row) => columns.filter(column => (column + row) % 2 === 0).map(column => {
      const bottom = rows[row + 1]
      return <path key={`${row}-${column}`} d={`M${project(column, top)} ${top}H${project(column + 1, top)}L${project(column + 1, bottom)} ${bottom}H${project(column, bottom)}Z`} fill="var(--color-sky)" opacity=".075" />
    }))}
  </svg>
}
